import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NavigationService from "../services/NavigationService";

// Hook to automatically track navigation history
export const useNavigationHistory = () => {
  const location = useLocation();

  useEffect(() => {
    // Save current page to navigation history
    NavigationService.saveCurrentPage(location.pathname);
  }, [location.pathname]);
};

export default useNavigationHistory;